__webpack_require__.p = "/Kuro-Assistance/";